<template>
  <div class="theme-search-area">
    <form @submit.prevent="search_flights">
      <div class="theme-search-area-form">
        <div class="row" data-gutter="10">
          <div class="col-md-6">
            <div class="row" data-gutter="10">
              <div class="col-md-6">
                <div
                  class="theme-search-area-section first theme-search-area-section-curved theme-search-area-section-fade-white"
                >
                  <div class="theme-search-area-section-inner">
                    <i class="theme-search-area-section-icon lin lin-location-pin"></i>
                    <autocomplete
                      class="form-control"
                      type="text"
                      name="origin"
                      v-model="origin"
                      v-validate="'required'"
                      :dataInitial="OriginFlightAutoCompleteDataInitial"
                      :placeholder="'Aeroporto de Origem'"
                    ></autocomplete>
                  </div>
                  <span class="error-message-forms">{{ errors.first('origin') }}</span>
                </div>
              </div>
              <div class="col-md-6">
                <div
                  class="theme-search-area-section theme-search-area-section-curved theme-search-area-section-fade-white"
                >
                  <div class="theme-search-area-section-inner">
                    <i class="theme-search-area-section-icon lin lin-location-pin"></i>
                    <autocomplete
                      class="form-control"
                      type="text"
                      name="destination"
                      v-model="destination"
                      v-validate="'required'"
                      :dataInitial="DestinationFlightAutoCompleteDataInitial"
                      :placeholder="'Aeroporto de Destino'"
                    ></autocomplete>
                  </div>
                  <span class="error-message-forms">{{ errors.first('destination') }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-5">
            <div class="row" data-gutter="10">
              <div class="col-md-8">
                <div
                  class="theme-search-area-section theme-search-area-section-curved theme-search-area-section-fade-white"
                >
                  <div class="theme-search-area-section-inner">
                    <i class="theme-search-area-section-icon lin lin-calendar"></i>
                    <date-range-picker
                      class="form-control"
                      name="date"
                      v-validate="'required'"
                      v-model="date"
                      :init="init"
                      :singlePick="!outbound_and_inbound"
                      ref="rangedate"
                      :placeholder="outbound_and_inbound ? 'Datas de ida e volta': 'Data de ida'"
                      sameDate="true"
                    ></date-range-picker>
                  </div>
                  <span class="error-message-forms">{{ errors.first('date') }}</span>
                </div>
              </div>
              <div class="col-md-4">
                <div class="theme-search-area-section theme-search-area-section-curved theme-search-area-section-fade-white quantity-selector" id="passengers" :class="{active: inputPassengers}">
                  <div class="theme-search-area-section-inner">
                    <i class="theme-search-area-section-icon lin lin-people"></i>
                    <div class="theme-search-area-section-input" @click="inputPassengers = !inputPassengers" style="white-space:nowrap;">{{totalPassengers}}
                    <span v-if="totalPassengers < 2">pessoa</span><span v-else>pessoas</span></div>
                    <span class="toggleIcon"></span>
                  </div>
                  <div id="inputPassengers">
                    <section>
                        <h4 style="margin-bottom:5px;">Adultos</h4>
                        <div>
                          <a class="btn btn-default minus" @click="sumAdults('minus')"><i class="fa fa-minus" aria-hidden="true"></i></a>
                          <input class="form-control" type="number" v-model="adults" disabled/>
                          <a class="btn btn-default plus" @click="sumAdults('plus')"><i class="fa fa-plus" aria-hidden="true"></i></a>
                        </div>
                    </section>
                    <section>
                        <h4>Crianças</h4>
                        <p>de 2 à 11 anos</p>
                        <div>
                          <a class="btn btn-default minus" @click="sumChildren('minus')"><i class="fa fa-minus" aria-hidden="true"></i></a>
                          <input class="form-control" type="number" v-model="children" disabled/>
                          <a class="btn btn-default plus" @click="sumChildren('plus')"><i class="fa fa-plus" aria-hidden="true"></i></a>
                        </div>
                    </section>
                    <section>
                        <h4>Bebês</h4>
                        <p>de 0 à 23 meses</p>
                        <div>
                          <a class="btn btn-default minus" @click="sumInfants('minus')"><i class="fa fa-minus" aria-hidden="true"></i></a>
                          <input class="form-control" type="number" v-model="infants" disabled/>
                          <a class="btn btn-default plus" @click="sumInfants('plus')"><i class="fa fa-plus" aria-hidden="true"></i></a>
                        </div>
                    </section>
                  </div>
                  <div id="inputPassengers-bg" @click="inputPassengers = !inputPassengers"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-1">
            <button
              type="submit"
              class="theme-search-area-submit _mt-0 theme-search-area-submit-no-border theme-search-area-submit-curved theme-search-area-submit-primary"
            >
              <i class="fa fa-search" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
    </form>
    <div class="theme-search-area-options theme-search-area-options-center clearfix">
      <div class="btn-group theme-search-area-options-list">
        <p-radio
          class="p-default p-round p-smooth p-plain"
          name="radio1"
          id="flight-option-1"
          color="primary-o"
          v-model="outbound_and_inbound"
          :checked="true"
          :value="true"
        >&nbsp;Ida e volta</p-radio>
        <p-radio
          class="p-default p-round p-smooth p-plain"
          name="radio1"
          color="primary-o"
          id="flight-option-2"
          :value="false"
          v-model="outbound_and_inbound"
        >&nbsp;Somente ida</p-radio>
      </div>
    </div>
  </div>
</template>

<script>
import Autocomplete from "./fields/flights/Autocomplete.vue";
import DateRangePicker from "./fields/DateRangePicker.vue";
import moment from "moment";
import alerts from "../mixins/alerts";

export default {
  data() {
    return {
      OriginFlightAutoCompleteDataInitial: [],
      DestinationFlightAutoCompleteDataInitial: [],
      init: {},
      origin: '',
      destination: '',
      date: '',
      adults: 1,
      children: 0,
      infants: 0,
      inputPassengers: false,
      submitted: false,
      outbound_and_inbound: true,
    };
  },
  props: ["flight"],
  components: {
    Autocomplete,
    DateRangePicker
  },
  beforeMount() {
    let params = this.$route.params;

    if (!Object.keys(params).length) return false;

    this.init = {
      startDate: params.outbound,
      endDate: params.inbound
    };

    if (!params.inbound) {
      this.outbound_and_inbound = false;
    }

    this.adults = params.adults || 1;
    this.children = params.children || 0;
    this.infants = params.infants || 0;
  },
  mounted() {
    if (this.$route.params.origin) {
      this._fillAutoComplete({ text: this.$route.params.origin }, "origin");
    }
    if (this.$route.params.destination) {
      this._fillAutoComplete({ text: this.$route.params.destination }, "destination");
    }
  },
  methods: {
    _fillAutoComplete(params, field) {
      if (!Object.keys(params).length) return false;
      if (field === "origin") {
        this.OriginFlightAutoCompleteDataInitial = [
          {
            text: params.text,
            id: params.text,
            el: {}
          }
        ];
        this.origin = this.OriginFlightAutoCompleteDataInitial[0];
      }
      if (field === "destination") {
        this.DestinationFlightAutoCompleteDataInitial = [
          {
            text: params.text,
            id: params.text,
            el: {}
          }
        ];
        this.destination = this.DestinationFlightAutoCompleteDataInitial[0];
      }
    },
    search_flights(e) {
      e.preventDefault();
      this.$validator.validate().then(valid => {
        this.submitted = true;
        if (valid) {
          const DATE_BR_FORMAT = 'DD/MM/YYYY';
          const DATE_ISO_8601 = 'YYYY-MM-DD';
          let going = moment(this.date.dateStart, DATE_BR_FORMAT).format(DATE_ISO_8601);
          let returning = moment(this.date.dateEnd, DATE_BR_FORMAT).format(DATE_ISO_8601);
          let url;
          if (this.outbound_and_inbound){
            url = `/flights/search/${this.origin.id}/${this.destination.id}/${this.adults}/${this.children}/${this.infants}/${going}/${returning}`;
          } else {
            url = `/flights/search/${this.origin.id}/${this.destination.id}/${this.adults}/${this.children}/${this.infants}/${going}`;
          }
          this.$router.push(url);

        } else {
          this.$swal({
            title: "Favor verificar os campos de busca",
            type: "error",
            confirmButtonText: "SAIR"
          });
        }
      });
    },
    sumAdults(op){
      if(op === 'plus' && this.adults < 100){
        this.adults = parseInt(this.adults) + 1
      }
      if(op === 'minus' && this.adults > 1){
        this.adults = parseInt(this.adults) - 1
      }
    },
    sumChildren(op){
      if(op === 'plus' && this.children < 100){
        this.children = parseInt(this.children) + 1
      }
      if(op === 'minus' && this.children > 0){
        this.children = parseInt(this.children) - 1
      }
    },
    sumInfants(op){
      if(op === 'plus' && this.infants < 100){
        this.infants = parseInt(this.infants) + 1
      }
      if(op === 'minus' && this.infants > 0){
        this.infants = parseInt(this.infants) - 1
      }
    },
  },
  computed: {
    totalPassengers(){
      return parseInt(this.adults) + parseInt(this.infants) + parseInt(this.children);
    }
  }
};
</script>

<style scoped>
#daterange {
  height: 55px !important;
  padding: 6px 40px;
  border: 0 !important;
  color: #6a6a6a !important;
  border-radius: 3px !important;
}
.theme-search-area-options-list {
  margin-right: -5px;
  color: #ffffff;
}
#passengers .theme-search-area-section-input{cursor: pointer;}
#inputPassengers{
  background: #fff;
  border-radius: 4px;
  border: 1px solid #ddd;
  display: none;
  left: 0;
  padding: 10px;
  position: absolute;
  top: 58px;
  width: 100%;
  z-index: 10;
}
#passengers.active #inputPassengers, #passengers.active #inputPassengers-bg{display: block;}
#passengers.active .toggleIcon{transform: rotate(180deg);}
#inputPassengers section{ margin-bottom: 10px;}
#inputPassengers section:last-child{margin: 0;}
#inputPassengers section div{position: relative;}
#inputPassengers h4{ margin: 0;}
#inputPassengers p{ font-size: 12px;}
#inputPassengers input{ text-align: center; width: 100%;}
#inputPassengers input:disabled{background:#fff;}
#inputPassengers .btn{
  border:0;
  height: 32px;
  padding: 6px 0;
  position: absolute;
  width: 32px;
  top: 1px;
}
#inputPassengers .plus{right:1px;}
#inputPassengers .minus{ left: 1px;}
#inputPassengers-bg {
  position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 1;
    display: none;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}
span.toggleIcon{
    border-color: #888 transparent transparent transparent;
    border-style: solid;
    border-width: 5px 4px 0 4px;
    height: 0;
    margin-left: -4px;
    margin-top: -2px;
    position: absolute;
    right: 10px;
    top: 50%;
    width: 0;
}
input[type=number] {
    -moz-appearance:textfield; /* Firefox */
}
</style>
